import React, { useState } from 'react';
import { Settings, Menu, Lightbulb, ClipboardList, GitBranch } from 'lucide-react';
import { SettingsModal } from './SettingsModal';
import { SignalRequestModal } from './library/signal-request/SignalRequestModal';
import styles from '../pages/ChatPage.module.css';
import { useOrderTicketNavigation } from '../features/order-ticket/navigation/OrderTicketNavigationContext';

interface ChatHeaderProps {
  sidebarCollapsed: boolean;
  onMobileMenuToggle?: () => void;
  isHidden?: boolean;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ sidebarCollapsed, onMobileMenuToggle, isHidden = false }) => {
  const [showSettings, setShowSettings] = useState(false);
  const [showSignalRequest, setShowSignalRequest] = useState(false);
  const { openOrderTicket, openStrategyOrderTicket } = useOrderTicketNavigation();

  return (
    <>
      <header className={`${styles.header} ${sidebarCollapsed ? styles.headerCollapsed : styles.headerExpanded} ${isHidden ? styles.hidden : ''}`}>
        <button
          className={styles.mobileMenuButton}
          onClick={onMobileMenuToggle}
          title="Menu"
        >
          <Menu size={24} />
        </button>
        <button
          className={styles.requestSignalButton}
          onClick={() => setShowSignalRequest(true)}
          data-tooltip="Request Signal"
        >
          <Lightbulb size={20} />
        </button>
        <button
          className={styles.orderTicketButton}
          onClick={() => openStrategyOrderTicket()}
          data-tooltip="Strategy Order"
          aria-label="Open strategy order ticket"
        >
          <GitBranch size={20} />
        </button>
        <button
          className={styles.orderTicketButton}
          onClick={() => openOrderTicket()}
          data-tooltip="Manual Order"
          aria-label="Open manual order ticket"
        >
          <ClipboardList size={20} />
        </button>
        <button
          className={styles.settingsButton}
          onClick={() => setShowSettings(true)}
          data-tooltip="Settings"
        >
          <Settings size={20} />
        </button>
      </header>

      <SettingsModal isOpen={showSettings} onClose={() => setShowSettings(false)} />
      <SignalRequestModal isOpen={showSignalRequest} onClose={() => setShowSignalRequest(false)} />
    </>
  );
};
